<template>
  <div class="fmt-tool">
    <div class="fmt-toolbar">
      <span class="fmt-label">{{ $t('tool.JsonEditor.title') }}</span>
      <span class="fmt-spacer" />
      <el-button size="small" icon="el-icon-s-operation" @click="process">{{ $t("common.action.format") }}</el-button>
      <el-button size="small" icon="el-icon-s-fold" @click="compress">{{ $t("common.action.compress") }}</el-button>
      <el-button size="small" icon="el-icon-circle-check" @click="validate">{{ $t("common.action.validate") }}</el-button>
      <el-button size="small" plain icon="el-icon-document-copy" @click="doCopy">{{ $t("common.action.copy") }}</el-button>
      <el-button size="small" plain @click="loadSample">{{ $t("common.action.sample") }}</el-button>
      <el-button size="small" plain icon="el-icon-delete" @click="clearAll">{{ $t("common.action.clear") }}</el-button>
    </div>
    <el-input v-model="code" type="textarea" :rows="18" :placeholder="$t('tool.JsonEditor.phInput')"
      class="fmt-textarea" @input="onInput" />
    <div class="fmt-status-bar">
      <span v-if="errorMsg" class="fmt-err"><i class="el-icon-warning" /> {{ errorMsg }}</span>
      <span v-else-if="code.trim()" class="fmt-ok"><i class="el-icon-circle-check" /> {{ $t('tool.JsonEditor.valid') }} · {{ charCount }}</span>
      <span v-else class="fmt-hint">{{ $t('tool.JsonEditor.hintEmpty') }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'JsonEditor',
  props: { config: { type: Object, default: () => ({}) } },
  data: () => ({ code: '', errorMsg: '' }),
  computed: {
    charCount() { return this.$t('common.hint.charCount', { n: this.code.length }) },
    indentSize() { return (this.config.options && this.config.options.indentSize) || 2 }
  },
  methods: {
    onInput() { this.errorMsg = '' },
    process() {
      this.errorMsg = ''
      if (!this.code.trim()) return
      try { this.code = JSON.stringify(JSON.parse(this.code), null, this.indentSize) }
      catch (e) { this.errorMsg = e.message }
    },
    compress() {
      this.errorMsg = ''
      if (!this.code.trim()) return
      try { this.code = JSON.stringify(JSON.parse(this.code)) }
      catch (e) { this.errorMsg = e.message }
    },
    validate() {
      this.errorMsg = ''
      if (!this.code.trim()) return
      try { JSON.parse(this.code); this.$message.success(this.$t('tool.JsonEditor.validatePass')) }
      catch (e) { this.errorMsg = e.message }
    },
    doCopy() {
      if (!this.code.trim()) { this.$message.warning(this.$t('tool.JsonEditor.noContent')); return }
      navigator.clipboard.writeText(this.code).then(() => this.$message.success(this.$t("common.status.copied"))).catch(() => {
        var ta = document.createElement('textarea'); ta.value = this.code
        ta.style.cssText = 'position:fixed;left:-9999px'; document.body.appendChild(ta); ta.select()
        try { document.execCommand('copy'); this.$message.success(this.$t("common.status.copied")) } catch(e) { this.$message.error(this.$t('tool.JsonEditor.copyFailed')) }
        document.body.removeChild(ta)
      })
    },
    loadSample() {
      this.code = JSON.stringify({ name:'example',items:[1,2,3],active:true,config:{theme:'dark',version:2}},null,2)
      this.errorMsg = ''
    },
    clearAll() { this.code = ''; this.errorMsg = '' },
    doAction(a) {
      if (a === 'format') this.process()
      if (a === 'compress') this.compress()
      if (a === 'validate') this.validate()
      if (a === 'copy') this.doCopy()
      if (a === 'clear') this.clearAll()
      if (a === 'sample') this.loadSample()
    }
  }
}
</script>

<style scoped>
.fmt-tool { display: flex; flex-direction: column; gap: 12px; }

.fmt-toolbar { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }
.fmt-toolbar >>> .el-button + .el-button { margin-left: 0; }
.fmt-label { font-size: 13px; font-weight: 700; color: #1a1f36; }
.fmt-spacer { flex: 1; }

.fmt-textarea >>> textarea {
  font-family: 'JetBrains Mono','Fira Code','Consolas',monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 10px; resize: vertical; min-height: 360px;
}

.fmt-status-bar { font-size: 12px; }
.fmt-err { color: #f56c6c; display: flex; align-items: center; gap: 4px; }
.fmt-ok { color: #67c23a; display: flex; align-items: center; gap: 4px; }
.fmt-hint { color: #c0c4cc; }
</style>
